<template>
  <div>
    <div class="right_menu">
      <div class="draw">
        <div class="left">
          <div class="models">
            <div class="ckpt">
              <span></span>
              <select v-model="ckpt_model_selected">
                <option :value="item" v-for="item in checkpoint_list" :key="item">{{ item }}</option>
              </select>
            </div>
            <div class="loras">
              <el-switch v-model="stack" active-color="rgb(252, 119, 22)" inactive-color="rgb(35, 37, 41)">
              </el-switch>
              <div class="title_lora">Lora应用堆栈 </div>
              <div class="iconfont">&#xe834;</div>
            </div>
          </div>
          <div v-if="stack" class="lora">
            <div class="lora_1">
              <span class="iconfont title">&#xe834;</span>
              <span>Lora模型一权重值:</span>
              <select name="" id="" v-model="lora_1_switch">
                <option value="Off">Off</option>
                <option value="On">On</option>
              </select>
              <input type="number" max="1.00" value="1.00">
              <span class="iconfont">&#xe66e;Clip权重:</span>
              <input type="number" max="1.00" value="1.00">
              <select name="" id="" v-model="lora_1_selected">
                <option :value="item" v-for="item in loras_list" :key="item">{{ item }}</option>
              </select>
              <span class="iconfont gallery">&#xe834;</span>
            </div>
            <div class="lora_2">
              <span class="iconfont title">&#xe834;</span>
              <span>Lora模型二权重值:</span>
              <select name="" id="" v-model="lora_2_switch">
                <option value="Off">Off</option>
                <option value="On">On</option>
              </select>
              <input type="number" max="1.00" value="1.00">
              <span class="iconfont">&#xe66e;Clip权重:</span>
              <input type="number" max="1.00" value="1.00">
              <select name="" id="" v-model="lora_2_selected">
                <option :value="item" v-for="item in loras_list" :key="item">{{ item }}</option>
              </select>
              <span class="iconfont gallery">&#xe834;</span>
            </div>
            <div class="lora_3">
              <span class="iconfont title">&#xe834;</span>
              <span>Lora模型三权重值:</span>
              <select name="" id="" lora_3_switch>
                <option value="">Off</option>
                <option value="">On</option>
              </select>
              <input type="number" max="1.00" value="1.00">
              <span class="iconfont">&#xe66e;Clip权重:</span>
              <input type="number" max="1.00" value="1.00">
              <select name="" id="" v-model="lora_3_selected">
                <option :value="item" v-for="item in loras_list" :key="item">{{ item }}</option>
              </select>
              <span class="iconfont gallery">&#xe834;</span>
            </div>
          </div>
          <div class="positive">
            <div class="icon">
              <div class="tips">
                <span class="iconfont">&#xe603;</span>
                <span>正向提示词[positive]</span>
              </div>
              <div class="fn">
                <span @click="copyToClipboard('positive')" title="点击复制内容"></span>
                <span @click="clear_prompt('positive')" title="点击清空内容"></span>
                <span @click="getClipboardText('positive')" title="点击粘贴内容"></span>
                <span v-if="translate" class="iconfont" title="点击切换为英文输入模式" @click="toggleTranslate">&#xebe2;</span>
                <span v-else class="iconfont" title="点击切换为中文输入模式" @click="toggleTranslate">&#xebe0;</span>
              </div>
            </div>
            <textarea placeholder="请输入正向提示词" v-model="positive_prompt">
            </textarea>
          </div>
          <div class="negative">
            <div class="icon">
              <div class="tips">
                <span class="iconfont">&#xe603;</span>
                <span>负向提示词[negative]</span>
              </div>
              <div class="fn">
                <span @click="copyToClipboard('negative')" title="点击复制内容"></span>
                <span @click="clear_prompt('negative')" title="点击清空内容"></span>
                <span @click="getClipboardText('negative')" title="点击粘贴内容"></span>
                <span v-if="translate" class="iconfont" title="点击切换为英文输入模式" @click="toggleTranslate">&#xebe2;</span>
                <span v-else class="iconfont" title="点击切换为中文输入模式" @click="toggleTranslate">&#xebe0;</span>
              </div>
            </div>
            <textarea placeholder="请输入负向提示词" v-model="negative_prompt"></textarea>
          </div>
          <div class="upload_image">
            <span> 请上传图片</span>
            <span @click="deleteImage()"> 清空</span>
            <div @click="handleImageUploadClick('upload')" @dragover.prevent @drop="handleImageDrop($event, 'upload')"
              v-loading="loading">
              <span class="upload">
                拖拽或点击上传图片</span>
              <img v-if="upload" :src="upload" alt="">
            </div>
          </div>
          <div class="resolution">
            <div class="width">
              <div class="px">
                <span> 宽度Width</span>
                <input type="number" v-model.number="width" max="1536">
              </div>
              <div class="slider">
                <el-slider v-model="width" :max="1536"></el-slider>
              </div>
            </div>
            <div class="gap"></div>
            <div class="height">
              <div class="px">
                <span> 高度Height</span>
                <input type="number" v-model.number="height" max="1536">
              </div>
              <div class="slider">
                <el-slider v-model="height" :max="1536"></el-slider>
              </div>
            </div>
            <div class="gap"></div>
            <div class="count">
              <div class="px">
                <span> 数量Count</span>
                <input type="number" v-model.number="count" max="1" min="1">
              </div>
              <div class="slider">
                <el-slider v-model="count" :max="1" :min="0"></el-slider>
              </div>
            </div>
          </div>
          <div class="ksamper_list">
            <div class="ksamper">
              <div class="ksa">
                <span class="iconfont">&#xe62b; 采样器Ksampler</span>
                <select class="ksa_list" v-model="ksa_selected">
                  <option class="options" :value="item" v-for="item in ksa_list" :key="item">{{ item }}</option>
                </select>
              </div>
              <div class="sch">
                <span> 调度器Schedule</span>
                <select class="sch_list" v-model="sch_selected">
                  <option class="options" :value="item" v-for="item in sch_list" :key="item">{{ item }}</option>
                </select>
              </div>
            </div>
            <div class="gap"></div>
            <div class="steps">
              <div class="step">
                <span> 采样步数Steps</span>
                <input type="number" v-model.number="steps" max="50">
              </div>
              <div class="slider">
                <el-slider v-model="steps" :max="50"></el-slider>
              </div>
            </div>
          </div>
          <div class="parameters">
            <div class="param_1">
              <div class="seed">
                <div class="one">
                  <span> 随机种子Seed</span>
                  <div class="gap"></div>
                  <span class="iconfont">&#xe675; 放大{{ open }}</span>
                  <el-switch v-model="scale" active-color="rgb(252, 119, 22)" inactive-color="rgb(35, 37, 41)"
                    :change="scale_apply()">
                  </el-switch>
                  <input class="scale" type="number" value="1.5" v-model="scale_factor" min="0.1" max="4.0" step="0.1">
                </div>
                <div class="two">
                  <input class="seed_id" type="number" value="2025052215980585277" v-model="seed" step="1">
                  <button class="fun" @click="randomint()">全部随机</button>
                  <button class="fun" @click="fixed_int()">固定种子</button>
                </div>
                <div class="three iconfont">&#xe65e; 历史种子Seed</div>
                <div class="his_seed">
                  <select class="seed_list" v-model="seed_his_seleted">
                    <option class="options" :value="item" v-for="(item, index) in seed_his_list" :key="index">{{ item }}
                    </option>
                  </select>
                  <button @click="get_seed_id()">捕获历史</button>
                </div>
                <div class="cfg_title">
                  <span> 引导系数CFG</span>
                  <span> 跳过引导层Clip Skip</span>
                </div>
                <div class="cfg_param">
                  <input type="number" value="8.0" v-model="cfg">
                  <span></span>
                  <input type="number" value="-1" style="text-align: right;" min="-12" max="-1" step="-1"
                    v-model="skip_clip">
                </div>
                <div class="denoise"> 添加噪声Denoise</div>
                <input class="denoise_value" type="number" value="1.0" v-model="denoise" min="0.00" max="1.00"
                  step="0.01">
              </div>
            </div>
            <div class="gap"></div>
            <div class="button">
              <button @click="start_process()"> 开始生成图像</button>
              <button @click="(dialogVisible = true, msg = '将清空图像预览面板,重置任务线程!', fun = 'clear')"> 清空预览窗口</button>
              <button @click="(dialogVisible = true, msg = '将临时保存到浏览器数据库,防止参数丢失!', fun = 'save')"> 保存临时参数</button>
              <button @click="(dialogVisible = true, msg = '确定重置参数么?将恢复默认设置!', fun = 'reset')"> 重置所有参数</button>
            </div>
            <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" height="20%" class="custom-dialog">
              <span class="text">{{ msg }}</span>
              <span slot="footer" class="dialog-footer">
                <el-button class="cancle" @click="dialogVisible = false">取 消</el-button>
                <el-button class="ok" type="primary" @click="dialog()">确 定</el-button>
              </span>
            </el-dialog>
          </div>
          <div class="sdpara">
            <div class="switch">
              <span>更多SD控制参数面板</span>
              <el-switch v-model="value2" active-color="rgb(252, 119, 22)" inactive-color="rgb(35, 37, 41)">
              </el-switch>
            </div>
            <span>OS:Controlnet参数控制选项卡</span>
          </div>
          <div v-if="value2 == true" class="ctrl">
            <div v-if="value2 == true" class="ctrl_1">
              <div class="one">
                <span class="iconfont">&#xe64f; ControlNet {{ appone }}</span>
                <el-switch v-model="ctrl_1" active-color="rgb(252, 119, 22)" inactive-color="rgb(35, 37, 41)"
                  :change="swtich_amount()">
                </el-switch>
                <div class="gap"></div>
                <span class="iconfont">&#xe934;</span>
                <select name="" id="" v-model="processor_selected_1">
                  <option :value="item" v-for="item in processor_1" :key="item">{{ item }}</option>
                </select>
                <span>&</span>
                <select name="" id="" v-model="ctrl_1_model_selected">
                  <option :value="item" v-for="item in ctrl_1_model" :key="item">{{ item }}</option>
                </select>
              </div>
              <div class="two">
                <span> 控制强度</span>
                <input type="number" min="0" max="1" step="0.01" value="1.00" v-model="ctrl_1_strength">
                <div class="gap"></div>
                <span class="iconfont">&#xe794; 起始点(Start):</span>
                <input type="number" min="0" max="1" step="0.01" value="1.00" v-model="ctrl_1_start">
                <span class="iconfont">&#xe794; 终止点(End):</span>
                <input type="number" min="0" max="1" step="0.01" value="1.00" v-model="ctrl_1_end">
              </div>
              <div class="three">
                <span> 上传图片</span>
                <span @click="clear_ctrl('ctrl_1')"> 清空图像</span>
                <div v-loading="loading" @click="handleImageUploadClick('ctrl_1')" @dragover.prevent
                  @drop="handleImageDrop($event, 'ctrl_1')">
                  <span class="upload"> 点击上传图片</span>
                  <img v-if="ctrl_1_image" class="ctrl_image" :src="ctrl_1_image" alt="">
                </div>
              </div>
            </div>
            <div v-if="ctrl_1 == true" class="ctrl_2">
              <div class="one">
                <span class="iconfont">&#xe64f; ControlNet {{ apptwo }}</span>
                <el-switch v-model="ctrl_2" active-color="rgb(252, 119, 22)" inactive-color="rgb(35, 37, 41)"
                  :change="swtich_amount()">
                </el-switch>
                <div class="gap"></div>
                <span class="iconfont">&#xe934;</span>
                <select name="" id="">
                  <option value="item" v-for="item in processor_2" :key="item">{{ item }}</option>
                </select>
                <span>&</span>
                <select name="" id="" v-model="ctrl_2_model_selected">
                  <option :value="item" v-for="item in ctrl_2_model" :key="item">{{ item }}</option>
                </select>
              </div>
              <div class="two">
                <span> 控制强度</span>
                <input type="number" min="0" max="1" step="0.01" value="1.00" v-model="ctrl_2_strength">
                <div class="gap"></div>
                <span class="iconfont">&#xe794; 起始点(Start):</span>
                <input type="number" min="0" max="1" step="0.01" value="1.00" v-model="ctrl_2_start">
                <span class="iconfont">&#xe794; 终止点(End):</span>
                <input type="number" min="0" max="1" step="0.01" value="1.00" v-model="ctrl_2_end">
              </div>
              <div class="three">
                <span> 上传图片</span>
                <span @click="clear_ctrl('ctrl_2')"> 清空图像</span>
                <div v-loading="loading" @click="handleImageUploadClick('ctrl_2')" @dragover.prevent
                  @drop="handleImageDrop($event, 'ctrl_2')">
                  <span class="upload"> 点击上传图片</span>
                  <img v-if="ctrl_2_image" class="ctrl_image" :src="ctrl_2_image" alt="">
                </div>
              </div>
            </div>
            <div v-if="ctrl_2 == true" class="ctrl_3">
              <div class="one">
                <span class="iconfont">&#xe64f; ControlNet {{ appthree }}</span>
                <el-switch v-model="ctrl_3" active-color="rgb(252, 119, 22)" inactive-color="rgb(35, 37, 41)"
                  :change="swtich_amount()">
                </el-switch>
                <div class="gap"></div>
                <span class="iconfont">&#xe934;</span>
                <select name="" id="">
                  <option value="item" v-for="item in processor_3" :key="item">{{ item }}</option>
                </select>
                <span>&</span>
                <select name="" id="" v-model="ctrl_3_model_selected">
                  <option :value="item" v-for="item in ctrl_3_model" :key="item">{{ item }}</option>
                </select>
              </div>
              <div class="two">
                <span> 控制强度</span>
                <input type="number" min="0" max="1" step="0.01" value="1.00" v-model="ctrl_3_strength">
                <div class="gap"></div>
                <span class="iconfont">&#xe794; 起始点(Start):</span>
                <input type="number" min="0" max="1" step="0.01" value="1.00" v-model="ctrl_3_start">
                <span class="iconfont">&#xe794; 终止点(End):</span>
                <input type="number" min="0" max="1" step="0.01" value="1.00" v-model="ctrl_3_end">
              </div>
              <div class="three">
                <span> 上传图片</span>
                <span @click="clear_ctrl('ctrl_3')"> 清空图像</span>
                <div v-loading="loading" @click="handleImageUploadClick('ctrl_3')" @dragover.prevent
                  @drop="handleImageDrop($event, 'ctrl_3')">
                  <span class="upload"> 点击上传图片</span>
                  <img v-if="ctrl_3_image" class="ctrl_image" :src="ctrl_3_image" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="middle"></div>
        <div class="right">
          <div class="show_image"> 显示面板</div>
          <div class="panel">
            <div v-if="tips" class="tips">{{ tips }}</div>
            <img v-if="this.processedImage" :src="this.processedImage" alt="">
            <div class="copy_path iconfont" title="复制图像地址" @click="copy_path(processedImage)">&#xe660; 复制</div>
          </div>
          <div class="fn_2">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ksampler from '@/utils/comfyUIKsamplerList.js'
import { Message } from 'element-ui'
import { v4 as uuidv4 } from 'uuid'
import { genPrompt } from '@/api/prompt'
import { genOssImage } from '@/utils/ossPath'
import { getLastUsedBaseUrl, cudaIndexNum } from '@/utils/comfyUiRequest'
import axios from 'axios'
import cuda from '@/utils/checkCuda'
import { getOssClient } from '@/utils/oss'
import random from 'random'
import localStorageUtils from '@/utils/setLocalStorage'
import request from '@/utils/comfyUiConfigRequest'
import { getTaskEnd, getTaskStart, updateConfig } from '@/api/user'
import { getCacheParams } from '@/utils/helper/paramsCache'
import { T_SD_ITI } from '@/enums/common/modules'
import { getImageSizeByLoading } from '@/utils/helper/function'
import { OSS_ACCESS_KEY_ID, OSS_ACCESS_KEY_SECRET, BAIDU_TRANSLATE_API_KEY, BAIDU_TRANSLATE_API_KEY_2 } from '@/utils/secretCrypto'
export default {
  name: 'PromptImage',
  data() {
    return {
      taskLogId: '',
      value1: '',
      value2: false,
      ctrl_1: false,
      ctrl_2: false,
      ctrl_3: false,
      stack: false,
      appone: '关闭',
      apptwo: '关闭',
      appthree: '关闭',
      selectedModel: '',
      loading: false,

      // 入参列表
      // 模型
      checkpoint_list: [],
      ckpt_model_selected: 'v1-5-pruned-emaonly-fp16.safetensors',
      loras_list: [],
      loras_selected: 'A001LCM/pytorch_lora_weights.safetensors',

      // 模型开关
      lora_1_switch: 'On',
      lora_1_weight: 1.00,
      lora_1_clip: 1.00,
      lora_1_selected: 'A001LCM/pytorch_lora_weights.safetensors',

      lora_2_switch: 'Off',
      lora_2_weight: 1.00,
      lora_2_clip: 1.00,
      lora_2_selected: 'A001LCM/pytorch_lora_weights.safetensors',

      lora_3_switch: 'Off',
      lora_3_weight: 1.00,
      lora_3_clip: 1.00,
      lora_3_selected: 'A001LCM/pytorch_lora_weights.safetensors',

      // 正向提示词
      positive_prompt: '',
      negative_prompt: '(worst quality, low quality, blurry, bad eye, ),(wrong hand, bad anatomy, wrong anatomy, ),(cgi, illustration, cartoon, poorly drawn, watermark),head out of frame,',

      // 分辨率和数量
      width: 512,
      height: 512,
      count: 1,

      // 采样器和调度器
      ksa_list: null,
      ksa_selected: 'lcm',
      sch_list: null,
      sch_selected: 'normal',
      steps: 10,

      // 放大选择和系数
      scale: false,
      scale_factor: 1.5,
      open: '关闭',

      // 历史种子列表
      seed: '2025052215980585277',
      seed_his_list: ['历史种子列表'],
      seed_his_seleted: '历史种子列表',

      // 固定种子
      random_status: false,
      fixed: -1,
      randomise: '',

      // 引导系数
      cfg: 1.4,
      skip_clip: -1,
      denoise: 0.3,

      // ctrl
      ctrl_source_model: 'None',
      ctrl_switch_1: 'Off',
      processor_1: null,
      processor_selected_1: 'none',
      ctrl_1_model: ['None'],
      ctrl_1_model_selected: 'None',
      ctrl_1_strength: 1.0,
      ctrl_1_start: 0.0,
      ctrl_1_end: 1.0,
      ctrl_1_image: null,

      ctrl_switch_2: 'Off',
      processor_2: null,
      processor_selected_2: 'none',
      ctrl_2_model: ['None'],
      ctrl_2_model_selected: 'None',
      ctrl_2_strength: 1.0,
      ctrl_2_start: 0.0,
      ctrl_2_end: 1.0,
      ctrl_2_image: null,

      ctrl_switch_3: 'Off',
      processor_3: null,
      processor_selected_3: 'none',
      ctrl_3_model: ['None'],
      ctrl_3_model_selected: 'None',
      ctrl_3_strength: 1.0,
      ctrl_3_start: 0.0,
      ctrl_3_end: 1.0,
      ctrl_3_image: null,

      // 其他参数
      imageSrc: '',
      imagePath: '',
      processedImage: '',
      tips: false,
      current: '',
      processing: false,
      websocket: null,
      ws: null,
      clientId: '',
      dialogVisible: false,
      msg: '',
      upload: null,
      translate: true
    }
  },
  created() {
    this.ksa_list = ksampler.ksampernames
    this.sch_list = ksampler.schedualnames
    this.processor_1 = ksampler.preprocessorlist
    this.processor_2 = ksampler.preprocessorlist
    this.processor_3 = ksampler.preprocessorlist
    this.processedImage = localStorageUtils.getItem('i2ishow_image')
    this.upload = localStorageUtils.getItem('upload_image')
    this.ctrl_1_image = localStorageUtils.getItem('i2ictrl_1_image')
    this.ctrl_2_image = localStorageUtils.getItem('i2ictrl_2_image')
    this.ctrl_3_image = localStorageUtils.getItem('i2ictrl_3_image')
    const cacheParams = getCacheParams(T_SD_ITI)
    const { checkpoints, positive, negative, width, height, count, ksamplerlist, scheduler, steps, cfg, skipclip, denoise } = cacheParams
    this.ckpt_model_selected = checkpoints || 'v1-5-pruned-emaonly-fp16.safetensors'
    this.positive_prompt = positive || ''
    this.negative_prompt = negative || '(worst quality, low quality, blurry, bad eye, ),(wrong hand, bad anatomy, wrong anatomy, ),(cgi, illustration, cartoon, poorly drawn, watermark),head out of frame,'
    this.width = Number(width) || 512
    this.height = Number(height) || 512
    this.count = Number(count) || 1
    this.ksa_selected = ksamplerlist || 'lcm'
    this.sch_selected = scheduler || 'normal'
    this.steps = Number(steps) || 10
    this.cfg = Number(cfg) || 1.4
    this.skip_clip = Number(skipclip) || -1
    this.denoise = Number(denoise) || 0.3
    this.source_negative()
  },
  async mounted() {
    [this.checkpoint_list, this.loras_list, this.ctrl_source_model] = await this.get_model_list() || [[], [], ['None']]
    this.ctrl_1_model = this.ctrl_1_model.concat(this.ctrl_source_model)
    this.ctrl_2_model = this.ctrl_2_model.concat(this.ctrl_source_model)
    this.ctrl_3_model = this.ctrl_3_model.concat(this.ctrl_source_model)
    // 添加键盘事件监听器
    window.addEventListener('keydown', this.handleKeystart)
    // 重刷新释放cuda
    window.addEventListener('beforeunload', this.releaseCuda)
  },
  async beforeDestroy() {
    // 移除键盘事件监听器以防止内存泄漏
    window.removeEventListener('keydown', this.handleKeystart)
    try {
      // 释放cuda状态
      const index = await cudaIndexNum()
      if (index) {
        await cuda.changeCudaCurrentStatus(index, 'leisure')
        console.log('current cuda is leisure')
      }
    } catch (e) {
      console.log('no cuda is running')
    }
    // 移除cuda释放监听器
    window.removeEventListener('beforeunload', this.releaseCuda)
  },
  methods: {
    // 释放cuda
    async releaseCuda() {
      try {
        // 释放cuda状态
        const index = await cudaIndexNum()
        if (index) {
          await cuda.changeCudaCurrentStatus(index, 'leisure')
          console.log('current cuda is leisure')
        }
      } catch (e) {
        console.log('no cuda is running')
      }
    },
    // 复制图像地址
    async copy_path(path) {
      if (!path) {
        Message.error('图像地址为空,请确认是否生成图像！')
        return
      }
      try {
        // 不兼容已弃用
        // await navigator.clipboard.writeText(path)

        // 兼容性更好
        const textarea = document.createElement('textarea')
        textarea.value = path
        textarea.style.position = 'fixed'
        textarea.style.opacity = '0'
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)
        Message.success('复制内容成功,可进行下一步操作！')
      } catch {
        Message.error('复制内容失败,请稍后再试！')
      }
    },
    // 添加开始快捷键
    handleKeystart(event) {
      // 检查是否按下了 Ctrl + D
      if (event.ctrlKey && event.key === 'Enter') {
        event.preventDefault() // 阻止默认行为（可选）
        this.start_process() // 执行返回主页的操作
      }
    },
    source_negative() {
      if (this.translate === false) {
        this.negative_prompt = '(worst quality, low quality, blurry, bad eye, ),(wrong hand, bad anatomy, wrong anatomy, ),(cgi, illustration, cartoon, poorly drawn, watermark),head out of frame,'
      }
      if (this.translate === true) {
        this.negative_prompt = '（最差质量、低质量、模糊、糟糕的视角），（错手、糟糕的解剖学、错误的解剖学），（电脑生成图像、插画、卡通、画得不好、有水印），头部出框'
      }
    },
    // 翻译功能
    toggleTranslate() {
      this.translate = !this.translate
      console.log(this.translate)
      Message.success(this.translate ? '翻译已开启,请用中文输入模式!' : '翻译已关闭,请用英文输入模式!')
      if (this.translate === false) {
        this.negative_prompt = '(worst quality, low quality, blurry, bad eye, ),(wrong hand, bad anatomy, wrong anatomy, ),(cgi, illustration, cartoon, poorly drawn, watermark),head out of frame,'
      }
      if (this.translate === true) {
        this.negative_prompt = '（最差质量、低质量、模糊、糟糕的视角），（错手、糟糕的解剖学、错误的解剖学），（电脑生成图像、插画、卡通、画得不好、有水印），头部出框'
      }
    },
    // 复制内容到剪切板
    async copyToClipboard(param) {
      if (param === 'positive') {
        if (!this.positive_prompt) {
          alert('请输入内容后再复制')
          return
        }
        try {
          await navigator.clipboard.writeText(this.positive_prompt)
          Message.success('内容已成功复制到剪切板!')
        } catch (err) {
          Message.error('复制失败,请检查浏览器是否支持该功能')
        }
      }
      if (param === 'negative') {
        if (!this.negative_prompt) {
          alert('请输入内容后再复制')
          return
        }
        try {
          await navigator.clipboard.writeText(this.negative_prompt)
          Message.success('内容已成功复制到剪切板!')
        } catch (err) {
          Message.error('复制失败,请检查浏览器是否支持该功能')
        }
      }
    },
    // 从剪切板获取内容
    async getClipboardText(param) {
      if (param === 'positive') {
        try {
          const text = await navigator.clipboard.readText()
          this.positive_prompt += text
          Message.success('内容已成功获取到剪切板!')
        } catch (err) {
          Message.error('获取内容失败,请检查浏览器是否支持该功能')
        }
      }
      if (param === 'negative') {
        try {
          const text = await navigator.clipboard.readText()
          this.negative_prompt += text
          Message.success('内容已成功获取到剪切板!')
        } catch (err) {
          Message.error('获取内容失败,请检查浏览器是否支持该功能')
        }
      }
    },
    // 清空提示词
    clear_prompt(param) {
      if (param === 'positive') {
        this.positive_prompt = ''
        Message.warning('已清空提示词,请重新输入提示词进行生成图片!')
      }
      if (param === 'negative') {
        this.negative_prompt = ''
        Message.warning('已清空提示词,请重新输入提示词进行生成图片!')
      }
    },
    // 删除图片
    deleteImage() {
      this.upload = null
      localStorage.removeItem('upload_image')
      Message.warning('已删除图片,请重新上传图片进行生成图片!')
    },
    // 清空控制图
    clear_ctrl(param) {
      if (param === 'ctrl_1') {
        this.ctrl_1_image = ''
        Message.warning('已清空控制图,请重新上传控制图进行生成图片!')
        localStorage.removeItem('i2ictrl_1_image')
      }
      if (param === 'ctrl_2') {
        this.ctrl_2_image = ''
        Message.warning('已清空控制图,请重新上传控制图进行生成图片!')
        localStorage.removeItem('i2ictrl_2_image')
      }
      if (param === 'ctrl_3') {
        this.ctrl_3_image = ''
        Message.warning('已清空控制图,请重新上传控制图进行生成图片!')
        localStorage.removeItem('i2ictrl_3_image')
      }
    },
    // 获取模型列表
    async get_model_list() {
      const res = await request.get('models/list')
      return [res.ckpt_name, res.loras, res.ctrl]
    },
    randomint() {
      this.random_status = false
      this.seed = Math.floor(Math.random() * 100000000000000)
      Message.warning('开启完全随机,SeedID将进入混乱随机!')
    },
    fixed_int() {
      this.random_status = true
      Message.warning('开启固定种子,SeedID将跟随输入确定!')
    },
    get_seed_id() {
      if (this.seed_his_list.length > 1) {
        const seed = this.seed_his_seleted
        this.seed = seed
      } else {
        Message.error('获取历史失败,种子列表未产生有效ID!')
      }
    },
    scale_apply() {
      if (this.scale === false) {
        this.open = '关闭'
      } else {
        this.open = '开启'
      }
    },
    total_swtich() {
      this.ctrl_1 = false
      this.ctrl_2 = false
      this.ctrl_3 = false
    },
    swtich_amount() {
      if (this.ctrl_1 === true) {
        this.appone = '开启'
      } else {
        this.appone = '关闭'
        this.ctrl_2 = false
        this.ctrl_3 = false
      }
      if (this.ctrl_2 === true) {
        this.apptwo = '开启'
      } else {
        this.apptwo = '关闭'
        this.ctrl_3 = false
      }
      if (this.ctrl_3 === true) {
        this.appthree = '开启'
      } else { this.appthree = '关闭' }
    },
    // 上传图片到OSS
    async uploadToOSS(file, ossClient) {
      const tmp = '/i2img/'
      const fileName = file.name
      try {
        const result = await ossClient.put(tmp + fileName, file)
        // console.log('上传成功:', result.url)
        return result.url
      } catch (err) {
        // console.error('上传到OSS失败:', err)
        return null
      }
    },
    // 点击上传按钮
    handleImageUploadClick(param) {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/*'
      input.onchange = (event) => {
        const file = event.target.files[0]
        if (file) {
          this.processImage(file, param)
        }
      }
      input.click()
    },
    // 拖拽上传事件
    handleImageDrop(event, param) {
      event.preventDefault()
      const file = event.dataTransfer.files[0]
      if (file && file.type.startsWith('image/')) {
        this.processImage(file, param)
      } else {
        Message.error('请上传有效的图片文件')
      }
    },
    // 图片处理函数
    async processImage(file, param) {
      this.loading = true
      const ossClient = await getOssClient()
      // 上传图片到OSS
      const imageUrl = await this.uploadToOSS(file, ossClient)
      console.log(imageUrl)
      if (param === 'upload') {
        this.upload = imageUrl
        localStorageUtils.setItem('upload_image', this.upload)
        this.loading = false
      }
      if (param === 'ctrl_1') {
        this.ctrl_1_image = imageUrl
        localStorageUtils.setItem('i2ictrl_1_image', this.ctrl_1_image)
        this.loading = false
      }
      if (param === 'ctrl_2') {
        this.ctrl_2_image = imageUrl
        localStorageUtils.setItem('i2ictrl_2_image', this.ctrl_2_image)
        this.loading = false
      }
      if (param === 'ctrl_3') {
        this.ctrl_3_image = imageUrl
        localStorageUtils.setItem('i2ictrl_3_image', this.ctrl_3_image)
        this.loading = false
      }
    },

    // 应用函数
    start_process() {
      this.processedImage = ''
      if (this.count !== 1) {
        Message.warning('请保持默认图像数量进行任务,为了负载均衡敬请谅解！')
        return
      }
      if (this.upload === '' || this.upload === null) {
        Message.warning('请上传图片后方可进行生成图片!')
        return
      }
      Message.success('提交参数开始执行任务,请耐心等待后台生成!')

      if (this.processing) {
        Message.warning('任务已在进行中，请勿重复提交以免造成错误!')
        return
      }
      if (this.random_status === false) {
        this.seed = Math.floor(Math.random() * 10000000000000000)
      } else {
        console.log(this.seed)
      }
      const seed = Number(this.seed)
      this.seed_his_list.push(seed)
      this.processing = true
      // 判断Ctrl入参状态
      if (this.ctrl_1 === true) {
        this.ctrl_switch_1 = 'On'
      } else {
        this.ctrl_switch_1 = 'Off'
        this.ctrl_1_image = 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/System_Default/MoreJoy.png'
      }
      if (this.ctrl_2 === true) {
        this.ctrl_switch_2 = 'On'
      } else {
        this.ctrl_switch_2 = 'Off'
        this.ctrl_2_image = 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/System_Default/MoreJoy.png'
      }
      if (this.ctrl_3 === true) {
        this.ctrl_switch_3 = 'On'
      } else {
        this.ctrl_switch_3 = 'Off'
        this.ctrl_3_image = 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/System_Default/MoreJoy.png'
      }
      // console.log(this.ctrl_switch_1)

      this.tips = '任务正在进行,预计等待5S-10S...'
      // const imagesrc = this.imagePath
      const filename = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
      const promptData = {
        1: {
          inputs: {
            text: [
              '109',
              0
            ],
            token_normalization: 'none',
            weight_interpretation: 'Stable diffusion',
            clip: [
              '93',
              1
            ]
          },
          class_type: 'AC_Stable Diffusion格式提示词',
          _meta: {
            title: 'AC_Stable Diffusion格式提示词'
          }
        },
        2: {
          inputs: {
            text: [
              '147',
              0
            ],
            token_normalization: 'none',
            weight_interpretation: 'Stable diffusion',
            clip: [
              '93',
              1
            ]
          },
          class_type: 'AC_Stable Diffusion格式提示词',
          _meta: {
            title: 'AC_Stable Diffusion格式提示词'
          }
        },
        5: {
          inputs: {
            ckpt_name: this.ckpt_model_selected
          },
          class_type: 'CheckpointLoaderSimple',
          _meta: {
            title: 'Load Checkpoint'
          }
        },
        7: {
          inputs: {
            seed: seed,
            steps: this.steps,
            cfg: this.cfg,
            sampler_name: this.ksa_selected,
            scheduler: this.sch_selected,
            denoise: this.denoise,
            model: [
              '93',
              0
            ],
            positive: [
              '46',
              0
            ],
            negative: [
              '46',
              1
            ],
            latent_image: [
              '121',
              0
            ]
          },
          class_type: 'KSampler',
          _meta: {
            title: 'KSampler'
          }
        },
        9: {
          inputs: {
            samples: [
              '7',
              0
            ],
            vae: [
              '5',
              2
            ]
          },
          class_type: 'VAEDecode',
          _meta: {
            title: 'VAE Decode'
          }
        },
        15: {
          inputs: {
            filename_prefix: 'ComfyUI',
            images: [
              '37',
              0
            ]
          },
          class_type: 'SaveImage',
          _meta: {
            title: 'Save Image'
          }
        },
        17: {
          inputs: {
            samples: [
              '19',
              0
            ],
            vae: [
              '45',
              0
            ]
          },
          class_type: 'VAEDecode',
          _meta: {
            title: 'VAE Decode'
          }
        },
        19: {
          inputs: {
            seed: seed,
            steps: this.steps,
            cfg: this.cfg,
            sampler_name: this.ksa_selected,
            scheduler: this.sch_selected,
            denoise: 0.3,
            model: [
              '93',
              0
            ],
            positive: [
              '1',
              0
            ],
            negative: [
              '2',
              0
            ],
            latent_image: [
              '22',
              0
            ]
          },
          class_type: 'KSampler',
          _meta: {
            title: 'KSampler'
          }
        },
        22: {
          inputs: {
            upscale_method: 'nearest-exact',
            scale_by: this.scale_factor,
            samples: [
              '7',
              0
            ]
          },
          class_type: 'LatentUpscaleBy',
          _meta: {
            title: 'Upscale Latent By'
          }
        },
        37: {
          inputs: {
            boolean: this.scale,
            on_true: [
              '17',
              0
            ],
            on_false: [
              '9',
              0
            ]
          },
          class_type: 'easy ifElse',
          _meta: {
            title: 'If else'
          }
        },
        45: {
          inputs: {
            vae_name: 'vae-84m-pruned_2.0.safetensors'
          },
          class_type: 'VAELoader',
          _meta: {
            title: 'Load VAE'
          }
        },
        46: {
          inputs: {
            positive: [
              '1',
              0
            ],
            negative: [
              '2',
              0
            ],
            cnet_stack: [
              '47',
              0
            ]
          },
          class_type: 'Apply ControlNet Stack',
          _meta: {
            title: 'Apply ControlNet Stack'
          }
        },
        47: {
          inputs: {
            switch_1: this.ctrl_switch_1,
            controlnet_1: this.ctrl_1_model_selected,
            controlnet_strength_1: this.ctrl_1_strength,
            start_percent_1: this.ctrl_1_start,
            end_percent_1: this.ctrl_1_end,
            switch_2: this.ctrl_switch_2,
            controlnet_2: this.ctrl_2_model_selected,
            controlnet_strength_2: this.ctrl_2_strength,
            start_percent_2: this.ctrl_2_start,
            end_percent_2: this.ctrl_2_end,
            switch_3: this.ctrl_switch_3,
            controlnet_3: this.ctrl_3_model_selected,
            controlnet_strength_3: this.ctrl_3_strength,
            start_percent_3: this.ctrl_3_start,
            end_percent_3: this.ctrl_3_end,
            image_1: [
              '101',
              0
            ],
            image_2: [
              '102',
              0
            ],
            image_3: [
              '104',
              0
            ]
          },
          class_type: 'CR Multi-ControlNet Stack',
          _meta: {
            title: '🕹️ CR Multi-ControlNet Stack'
          }
        },
        48: {
          inputs: {
            image: 'example.png',
            upload: 'image'
          },
          class_type: 'LoadImage',
          _meta: {
            title: 'Load Image'
          }
        },
        54: {
          inputs: {
            preprocessor: this.processor_selected_1,
            resolution: 512,
            image: [
              '48',
              0
            ]
          },
          class_type: 'AIO_Preprocessor',
          _meta: {
            title: 'AIO Aux Preprocessor'
          }
        },
        86: {
          inputs: {
            preprocessor: this.processor_selected_2,
            resolution: 512,
            image: [
              '87',
              0
            ]
          },
          class_type: 'AIO_Preprocessor',
          _meta: {
            title: 'AIO Aux Preprocessor'
          }
        },
        87: {
          inputs: {
            image: 'example.png',
            upload: 'image'
          },
          class_type: 'LoadImage',
          _meta: {
            title: 'Load Image'
          }
        },
        88: {
          inputs: {
            preprocessor: this.processor_selected_3,
            resolution: 512,
            image: [
              '89',
              0
            ]
          },
          class_type: 'AIO_Preprocessor',
          _meta: {
            title: 'AIO Aux Preprocessor'
          }
        },
        89: {
          inputs: {
            image: 'example.png',
            upload: 'image'
          },
          class_type: 'LoadImage',
          _meta: {
            title: 'Load Image'
          }
        },
        93: {
          inputs: {
            model: [
              '5',
              0
            ],
            clip: [
              '95',
              0
            ],
            lora_stack: [
              '94',
              0
            ]
          },
          class_type: 'CR Apply LoRA Stack',
          _meta: {
            title: '💊 CR Apply LoRA Stack'
          }
        },
        94: {
          inputs: {
            switch_1: this.lora_1_switch,
            lora_name_1: this.lora_1_selected,
            model_weight_1: this.lora_1_weight,
            clip_weight_1: this.lora_1_clip,
            switch_2: this.lora_2_switch,
            lora_name_2: this.lora_2_selected,
            model_weight_2: this.lora_2_weight,
            clip_weight_2: this.lora_2_clip,
            switch_3: this.lora_3_switch,
            lora_name_3: this.lora_3_selected,
            model_weight_3: this.lora_3_weight,
            clip_weight_3: this.lora_3_clip
          },
          class_type: 'CR LoRA Stack',
          _meta: {
            title: '💊 CR LoRA Stack'
          }
        },
        95: {
          inputs: {
            stop_at_clip_layer: this.skip_clip,
            clip: [
              '5',
              1
            ]
          },
          class_type: 'CLIPSetLastLayer',
          _meta: {
            title: 'CLIP Set Last Layer'
          }
        },
        97: {
          inputs: {
            filename: filename,
            access_key_id: OSS_ACCESS_KEY_ID,
            access_key_secret: OSS_ACCESS_KEY_SECRET,
            security_token: '',
            bucket_name: 'mj-comfy-ui',
            endpoint: 'oss-cn-shenzhen.aliyuncs.com',
            image: [
              '37',
              0
            ]
          },
          class_type: 'OSSUploadNode',
          _meta: {
            title: '保存图片到oss'
          }
        },
        101: {
          inputs: {
            boolean: this.ctrl_switch_1,
            on_true: [
              '110',
              0
            ],
            on_false: [
              '48',
              0
            ]
          },
          class_type: 'easy ifElse',
          _meta: {
            title: 'If else'
          }
        },
        102: {
          inputs: {
            boolean: this.ctrl_switch_2,
            on_true: [
              '111',
              0
            ],
            on_false: [
              '87',
              0
            ]
          },
          class_type: 'easy ifElse',
          _meta: {
            title: 'If else'
          }
        },
        104: {
          inputs: {
            boolean: this.ctrl_switch_3,
            on_true: [
              '112',
              0
            ],
            on_false: [
              '89',
              0
            ]
          },
          class_type: 'easy ifElse',
          _meta: {
            title: 'If else'
          }
        },
        106: {
          inputs: {
            text: this.positive_prompt,
            translate_from: 'zh',
            translate_to: 'en',
            APIID: '20250517002359356',
            APIKEY: BAIDU_TRANSLATE_API_KEY_2
          },
          class_type: 'AC_百度翻译',
          _meta: {
            title: 'AC_百度翻译'
          }
        },
        108: {
          inputs: {
            text: this.positive_prompt
          },
          class_type: 'Nodepad_啊程记事本',
          _meta: {
            title: 'Nodepad_啊程记事本'
          }
        },
        109: {
          inputs: {
            boolean: this.translate,
            on_true: [
              '106',
              0
            ],
            on_false: [
              '108',
              0
            ]
          },
          class_type: 'easy ifElse',
          _meta: {
            title: 'If else'
          }
        },
        110: {
          inputs: {
            image_url: this.ctrl_1_image
          },
          class_type: 'LoadImageFromURL',
          _meta: {
            title: '从url加载图片'
          }
        },
        111: {
          inputs: {
            image_url: this.ctrl_2_image
          },
          class_type: 'LoadImageFromURL',
          _meta: {
            title: '从url加载图片'
          }
        },
        112: {
          inputs: {
            image_url: this.ctrl_3_image
          },
          class_type: 'LoadImageFromURL',
          _meta: {
            title: '从url加载图片'
          }
        },
        114: {
          inputs: {
            image_url: this.upload
          },
          class_type: 'LoadImageFromURL',
          _meta: {
            title: '从url加载图片'
          }
        },
        118: {
          inputs: {
            upscale_method: 'nearest-exact',
            width: this.width,
            height: this.height,
            crop: 'center',
            image: [
              '114',
              0
            ]
          },
          class_type: 'ImageScale',
          _meta: {
            title: 'Upscale Image'
          }
        },
        120: {
          inputs: {
            pixels: [
              '118',
              0
            ],
            vae: [
              '5',
              2
            ]
          },
          class_type: 'VAEEncode',
          _meta: {
            title: 'VAE Encode'
          }
        },
        121: {
          inputs: {
            amount: this.count,
            samples: [
              '120',
              0
            ]
          },
          class_type: 'RepeatLatentBatch',
          _meta: {
            title: 'Repeat Latent Batch'
          }
        },
        145: {
          inputs: {
            text: this.negative_prompt
          },
          class_type: 'Nodepad_啊程记事本',
          _meta: {
            title: 'Nodepad_啊程记事本'
          }
        },
        146: {
          inputs: {
            text: this.negative_prompt,
            translate_from: 'zh',
            translate_to: 'en',
            APIID: '20250612002379955',
            APIKEY: BAIDU_TRANSLATE_API_KEY
          },
          class_type: 'AC_百度翻译',
          _meta: {
            title: 'AC_百度翻译'
          }
        },
        147: {
          inputs: {
            boolean: this.translate,
            on_true: [
              '146',
              0
            ],
            on_false: [
              '145',
              0
            ]
          },
          class_type: 'easy ifElse',
          _meta: {
            title: 'If else'
          }
        }
      }
      this.clientId = uuidv4()
      const data = {
        prompt: promptData,
        client_id: this.clientId
      }
      // 发送 Prompt 请求
      const sendPromptRequest = async () => {
        try {
          console.log('get prompt response', data)
          return genPrompt(data)
        } catch (error) {
          console.error('发送作图请求失败：', error)
          this.processing = false
          this.tips = false
          return null
        }
      }

      const fetchImageFilename = async (promptId) => {
        try {
          // 直接使用该实例请求历史记录
          const historyRequest = axios.create({
            baseURL: getLastUsedBaseUrl(),
            timeout: 5000,
            headers: {
              'Content-Type': 'application/json'
            }
          })

          const response = await historyRequest.get(`/history/${promptId}`)
          const promptInfo = response.data[promptId]
          // const response = await getImagePathByPrompt(promptId)
          // const promptInfo = response[promptId]
          const promptIndex = 2 // prompt信息的下标
          const inputIndex = 97 // prompt信息组件名的下标

          // console.log(promptInfo)
          if (promptInfo.status.status_str === 'success') {
            const tmp = JSON.parse(promptInfo.prompt[promptIndex][inputIndex].inputs.filename)

            const imagepath = genOssImage(tmp[0])
            localStorageUtils.setItem('i2ishow_image', imagepath)
            this.getTaskEnd(imagepath, this.taskLogId)
            this.processedImage = imagepath
            this.processing = false
            // 已弃用
            // const images = result[promptId]?.outputs?.[21]?.images
            // if (images && images.length > 0) {
            //   for (let i = 0; i < images.length; i++) {
            //     const outputFile = images[i].filename
            //     const tmp = `${serverAddress}/view?filename=${outputFile}&type=output`
            //     this.processedImage = tmp // 更新 processedImage
            //     this.tips = false // 关闭提示
            //   }
            // } else {
            //   console.error('未找到生成的图像文件')
            // }
          } else {
            console.error('获取历史记录失败，状态码：', response.status)
          }
        } catch (error) {
          console.error('获取图像文件名失败：', error)
        }
      }

      const listenToProgress = (promptId) => {
        this.ws = new WebSocket(`${getLastUsedBaseUrl()}/ws?clientId=${this.clientId}`)
        const wsTimeout = setTimeout(() => {
          Message.warning('网络连接超时,请重新尝试!')
          this.ws.close()
        }, 2000)

        this.ws.onopen = () => {
          console.log('提交服务器开始生成...')
          getTaskStart({
            type: T_SD_ITI
          }).then(rep => {
            this.taskLogId = rep.data.task.id
          })
          clearTimeout(wsTimeout)
        }
        this.ws.onmessage = async (event) => {
          clearTimeout(wsTimeout)
          const data = event.data
          if (typeof data === 'string') {
            try {
              const msg = JSON.parse(event.data)
              // const tmp = JSON.parse(data)
              // console.log(`这是返回${msg}`)
              // console.log(tmp)

              if (msg.type === 'executing') {
                const data = msg.data
                if (data.node === null && data.prompt_id === promptId) {
                  // console.log('执行完成')
                  this.ws.close()
                  await fetchImageFilename(promptId)
                }
              } else if (msg.type === 'progress') {
                const value = msg.data.value
                const max = msg.data.max
                const current = (value / max * 100).toFixed(2)
                this.tips = `大约完成：${current}%`
                // console.log(`大约完成：${current}%`)
              }
            } catch (error) {
              console.log('获取结果失败，请重试')
            }
          }
        }
        this.ws.onclose = async () => {
          // console.log('与后台链接断开')
          this.processing = false
          this.tips = false
          try {
            // 恢复cuda为空闲状态
            const index = cudaIndexNum()
            // console.log('回复当前cuda状态', index)
            await cuda.changeCudaCurrentStatus(index, 'leisure')
          } catch (error) { console.log(error) }
        }
      }

      (async () => {
        const result = await sendPromptRequest()
        if (result && result.prompt_id) {
          listenToProgress(result.prompt_id)
        }
      })()
    },
    async getTaskEnd(tmp, taskLogId) {
      const imgInfo = await getImageSizeByLoading(tmp)
      const info = {
        details: [{ path: tmp, imgInfo: imgInfo }]
      }
      getTaskEnd({ result: JSON.stringify(info) }, taskLogId)
    },
    // 重置所有参数
    resetAll() {
      this.ckpt_model_selected = 'v1-5-pruned-emaonly-fp16.safetensors'
      this.positive_prompt = ''
      this.negative_prompt = '(worst quality, low quality, blurry, bad eye, ),(wrong hand, bad anatomy, wrong anatomy, ),(cgi, illustration, cartoon, poorly drawn, watermark),head out of frame,'
      this.width = 512
      this.height = 512
      this.count = 1
      this.ksa_selected = 'lcm'
      this.sch_selected = 'normal'
      this.steps = 10
      this.cfg = 1.4
      this.skip_clip = -1
      this.denoise = 0.3
      const data = {
        checkpoints: this.ckpt_model_selected,
        positive: this.positive_prompt,
        negative: this.negative_prompt,
        width: this.width,
        height: this.height,
        count: this.count,
        ksamplerlist: this.ksa_selected,
        scheduler: this.sch_selected,
        steps: this.steps,
        cfg: this.cfg,
        skipclip: this.skip_clip,
        denoise: this.denoise

      }
      localStorageUtils.setItem('i2i_params', data)
    },
    // 清空预览窗口
    clear_result_show() {
      this.dialogVisible = true
      this.processedImage = ''
      localStorage.removeItem('i2ishow_image')
      this.processing = false
    },
    // 保存参数
    save_params() {
      const data = {
        checkpoints: this.ckpt_model_selected,
        positive: this.positive_prompt,
        negative: this.negative_prompt,
        width: this.width,
        height: this.height,
        count: this.count,
        ksamplerlist: this.ksa_selected,
        scheduler: this.sch_selected,
        steps: this.steps,
        cfg: this.cfg,
        skipclip: this.skip_clip,
        denoise: this.denoise

      }
      localStorageUtils.setItem(T_SD_ITI, data)
      updateConfig({
        type: T_SD_ITI,
        config: JSON.stringify(data)
      }).then(() => {
        Message.success('已正确保存参数到临时数据库!')
      }).finally(() => {
        this.dialogVisible = false
      })
    },
    // Dialog点击执行方法
    dialog() {
      if (this.fun === 'reset') {
        this.resetAll()
        Message.success('已重置所有默认参数!')
        this.dialogVisible = false
      }
      if (this.fun === 'save') {
        this.save_params()
      }
      if (this.fun === 'clear') {
        this.clear_result_show()
        Message.success('已清空面板且重置任务线程!')
        this.dialogVisible = false
        this.fun = ''
      }
    }

  }
}
</script>
<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

@keyframes ip_move {
  0% {
    padding-bottom: 5px;
  }

  50% {
    padding-bottom: 10px;
  }

  100% {
    padding-bottom: 5px;
  }
}

@keyframes opacity {
  0% {
    opacity: 0.4;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.4;
  }
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-family: "icomoon";
  overflow: hidden;
}

.active {
  transition: all 0.5s;
  background-color: @yellow;
  color: @font_black;
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 25px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

::v-deep {
  .el-slider__runway {
    height: 8px;
    border-radius: 8px;
    background-color: @font_gray;
  }

  .el-slider__bar {
    height: 8px;
    background-color: @morejoy;
  }

  .el-slider__button {
    position: absolute;
    top: 16%;
    width: 10px;
    height: 26px;
    border-radius: 20%;
    background-color: @morejoy;
    border: 1px solid @morejoy;
  }
}

::v-deep .el-select {
  width: 100%;

  .el-input__inner {
    color: white;
    border: none;
    font-size: 22px;
    outline: none;
  }
}

::v-deep .el-select {
  .el-select-dropdown {
    background-color: #1a1d24;
    border: 1px solid yellow;
    border-radius: 10px;

    &__item {
      color: white;
      font-size: 20px;
      padding: 12px 20px;
      transition: all 0.3s ease;

      &:hover,
      &:focus {
        background-color: #33373f;
        color: yellow;
      }

      &.selected {
        background-color: yellow;
        color: black;
        font-weight: bold;
      }
    }
  }
}

::v-deep .el-switch {
  height: 30px;
  width: 70px;

  .el-switch__core {
    position: relative;
    width: 70px !important;
    height: 23px;
    border-radius: 13px;
    background-color: #222;

    &::after {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 20px;
      height: 20px;
      background-color: white;
    }
  }

  .el-switch__label {
    font-size: 16px;
    color: @font_gray;
  }
}

// 弹窗
.custom-dialog {

  .custom-dialog .el-dialog__header {
    background-color: #eef1f6;
    border-bottom: 1px solid #dcdfe6;
    text-align: center;
  }

  .custom-dialog .el-dialog__footer {
    text-align: center;
  }

  .dialog-footer .el-button {
    margin: 0 5px;
    border: 1px solid @basicselect;
    color: @font_gray;
    border-radius: 10px;
    transition: all 0.5s;

    &:hover {
      transition: all 0.5s;
      background-color: @morejoy;
      color: @font_white;
    }
  }

  .ok,
  .cancle {
    background-color: white;
    display: inline-block;
    padding: 12px 15px;
    font-size: 22px;
  }

  span {
    font-size: 22px;
    color: @font_gray;
  }

}

.right_menu {
  // background-color: @basecolor;
  width: calc(100vw - 360px);
  height: calc(100vh - 95px);
  // overflow-y: scroll;
  color: @font_black;

  // scrollbar-width: thin;
  // scrollbar-color: rgb(31,34,36) transparent ;
  .draw {
    display: flex;
    padding: 10px 0px;
    font-family: "icomoon";

    .left {
      display: flex;
      flex-direction: column;
      width: 1350px;
      gap: 15px 0px;

      .models {
        height: 50px;
        display: flex;
        justify-content: space-between;
        font-size: 24px;
        color: @font_gray;

        .loras {
          display: flex;
          padding: 0px 10px;
          gap: 10px;
          align-items: center;
          justify-content: center;
          width: 300px;
          height: 50px;
          line-height: 50px;
          display: flex;
          border: 2px solid @basicselect;
          border-radius: 10px;

          div:nth-child(2) {
            font-size: 25px;
          }

          div:nth-child(3) {
            font-size: 30px;
          }
        }

        .ckpt {
          display: flex;
          padding: 0px 10px;
          gap: 10px;
          align-items: center;
          width: 500px;
          height: 50px;
          line-height: 50px;
          display: flex;
          border: 2px solid @basicselect;
          border-radius: 10px;

          span {
            display: inline-block;
            width: 35px;
          }

          select {
            width: 450px;
            height: 100%;
            background: none;
            outline: none;
            border: none;
            font-size: 22px;
            color: @font_gray;
            overflow: hidden;
          }

        }
      }

      .lora {
        display: flex;
        flex-direction: column;
        border: 2px solid @basicselect;
        border-radius: 15px;
        padding: 15px;
        transition: all 0.5s;

        .title {
          font-size: 30px;
        }

        .lora_1,
        .lora_2,
        .lora_3 {
          display: flex;
          align-items: center;
          height: 60px;
          font-size: 25px;
          color: @font_gray;
          gap: 0 10px;
          transition: all 0.5s;
        }

        input {
          width: 150px;
          height: 50px;
          border: 2px solid @basicselect;
          border-radius: 13px;
          padding: 3px;
          font-size: 21px;
          text-align: center;
          color: @font_gray;
          opacity: 0.6;

          &:hover,
          &:active {
            opacity: 1;
            transition: all 0.5s;
          }
        }

        select:nth-child(3) {
          width: 120px;
          height: 50px;
          font-size: 22px;
          color: @font_gray;
          padding: 5px 10px;
          border-radius: 12px;
          border: 2px solid @basicselect;
          background: none;
        }

        select:nth-child(7) {
          width: 430px;
          height: 50px;
          font-size: 22px;
          color: @font_gray;
          padding: 5px 10px;
          border-radius: 12px;
          border: 2px solid @basicselect;
          background: none;
        }

        .gallery {
          font-size: 30px;
          cursor: pointer;
        }
      }

      .positive,
      .negative {
        height: 250px;
        border: 2px solid @basicselect;
        border-radius: 20px;
        position: relative;

        .tips {
          display: flex;
          position: absolute;
          align-items: center;
          left: 15px;
          top: 15px;
          font-size: 22px;
          color: @font_gray;

          span {
            display: inline-block;
            padding: 0 5px;
          }
        }

        .fn {
          display: flex;
          position: absolute;
          width: 170px;
          right: 35px;
          bottom: 25px;
          font-size: 25px;
          z-index: 2;
          color: @font_gray;
          transition: all 0.5s;

          &:hover {
            cursor: pointer;
            transform: scale(1.02);
            transition: all 0.5s;
          }

          span {
            display: inline-block;
            padding: 0 8px;
          }
        }

        textarea {
          position: absolute;
          top: 40px;
          outline: none;
          border: none;
          width: 100%;
          height: 180px;
          background: none;
          padding: 10px 10px 20px 15px;
          color: @font_gray;
          resize: none;
          font-size: 22px;
        }
      }

      .upload_image {
        position: relative;
        width: 1350px;
        height: 550px;
        border: 2px solid @basicselect;
        border-radius: 25px;

        span:nth-child(1) {
          position: absolute;
          display: inline-block;
          padding: 10px 20px;
          color: @font_gray;
          font-size: 22px;
        }

        span:nth-child(2) {
          position: absolute;
          right: 20px;
          display: inline-block;
          padding: 10px 20px;
          color: @font_gray;
          cursor: pointer;
          transition: all 0.5s;
          font-size: 22px;

          &:hover {
            transition: all 0.5s;
            font-size: 23px;
          }
        }

        div {
          position: absolute;
          border-radius: 25px;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -47%);
          width: 1150px;
          height: 480px;
          background: @basicselect;

          .upload {
            display: block;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -47%);
            font-size: 25px;
            padding: 50px;
            transition: all 0.5s;
            cursor: pointer;
            z-index: 1;

            &:hover {
              font-size: 27px;
              transition: all 0.5s;
            }
          }

          img {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            height: 100%;
            width: auto;
            z-index: 2;
          }
        }
      }

      .resolution {
        display: flex;
        height: 130px;

        .gap {
          width: 10px;
        }

        // border: 2px solid @yellow;
        .width,
        .height,
        .count {
          display: flex;
          flex-direction: column;
          height: 100px;
          flex: 1;
          height: 100%;
          border: 2px solid @basicselect;
          border-radius: 25px;
          padding: 20px;
          color: @font_gray;

          .px {
            display: flex;
            height: 40px;
            font-size: 25px;
            align-items: center;

            span {
              flex: 1;
              display: inline-block;
            }

            input {
              flex: 1;
              width: calc(100% - 30px);
              height: 50px;
              border: 2px solid @basicselect;
              border-radius: 15px;
              padding: 3px;
              font-size: 21px;
              text-align: center;
              color: @font_gray;
              opacity: 0.6;

              &:hover,
              &:active {
                opacity: 1;
                transition: all 0.5s;
              }
            }
          }

          .slider {
            width: 100%;
            height: 50px;
            padding: 15px 0;
          }
        }
      }

      .ksamper_list {
        display: flex;
        height: 150px;
        color: @font_gray;

        .ksamper {
          flex: 1;
          flex-direction: column;
          display: flex;
          border-radius: 25px;
          border: 2px solid @basicselect;
          padding: 15px;

          .ksa,
          .sch {
            height: 60px;
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 25px;

            span {
              display: inline-block;
              padding: 0 5px;
            }

            .ksa_list,
            .sch_list {
              width: 350px;
              height: 50px;
              font-size: 22px;
              color: @font_gray;
              padding: 5px 10px;
              border-radius: 12px;
              border: 2px solid @basicselect;
              background: none;
            }
          }
        }

        .gap {
          width: 10px;
        }

        .steps {
          flex: 1;
          display: flex;
          flex-direction: column;
          border-radius: 25px;
          border: 2px solid @basicselect;
          padding: 15px;

          .step {
            display: flex;
            height: 60px;
            justify-content: space-between;
            align-items: center;
            font-size: 25px;

            span {
              display: inline-block;
            }

            input {
              height: 50px;
              border: 2px solid @basicselect;
              border-radius: 15px;
              padding: 3px;
              font-size: 21px;
              text-align: center;
              color: @font_gray;
              opacity: 0.6;

              &:hover,
              &:active {
                opacity: 1;
                transition: all 0.5s;
              }
            }
          }

          .slider {
            height: 60px;
            width: 100%;
            padding-top: 25px;

          }
        }
      }

      .parameters {
        display: flex;
        height: 450px;
        color: @font_gray;

        .param_1 {
          width: 1000px;
          height: 100%;
          border-radius: 25px;
          border: 2px solid @basicselect;
          padding: 15px;

          .seed {
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            font-size: 25px;
            // border: 2px solid @yellow;
            gap: 10px;

            .gap {
              width: 340px;
            }

            .one {
              align-items: center;
            }

            .one,
            .two {
              display: flex;
              height: 45px;
              justify-content: space-between;

              .fun {
                width: 140px;
                font-size: 22px;
                font-family: "icomoon";
                border: none;
                border-radius: 12px;
                background-color: @morejoy;
                cursor: pointer;
                color: @font_white;

                &:hover {
                  transition: all 0.3s;
                  font-size: 23px;
                }
              }

              .scale {
                width: 200px;
                height: 45px;
                border: 2px solid @basicselect;
                border-radius: 10px;
                text-align: center;
                color: @font_black;
                opacity: 0.6;
                font-size: 22px;

                &:hover,
                &:active {
                  opacity: 1;
                  transition: all 0.5s;
                }
              }

              .seed_id {
                width: 670px;
                border: 2px solid @basicselect;
                border-radius: 10px;
                text-align: left;
                padding: 0 10px;
                color: @font_black;
                font-size: 22px;
                opacity: 0.6;

                &:hover,
                &:active {
                  opacity: 1;
                  transition: all 0.5s;
                }
              }
            }

            .his_seed {
              display: flex;
              width: 100%;
              gap: 0 10px;

              .seed_list {
                width: 820px;
                height: 50px;
                border: 2px solid @basicselect;
                border-radius: 15px;
                padding: 3px;
                font-size: 21px;
                text-align: left;
                color: @font_black;
                opacity: 0.6;

                .option {
                  height: 50px;
                  font-size: 21px;
                }

                &:hover,
                &:active {
                  opacity: 1;
                  transition: all 0.5s;
                }
              }

              button {
                width: 140px;
                font-size: 22px;
                font-family: "icomoon";
                border: none;
                border-radius: 12px;
                background-color: @morejoy;
                cursor: pointer;
                color: @font_white;

                &:hover {
                  transition: all 0.3s;
                  font-size: 23px;
                }

              }
            }

            .cfg_title {
              display: flex;
              justify-content: space-between;
              font-size: 25px;

              span {
                display: inline-block;
              }
            }

            .cfg_param {
              display: flex;
              justify-content: space-between;

              span {
                display: inline-block;
                font-size: 50px;
              }

              input {
                height: 50px;
                width: 450px;
                border: 2px solid @basicselect;
                border-radius: 10px;
                text-align: left;
                padding: 0 10px;
                color: @font_black;
                font-size: 22px;
                opacity: 0.6;

                &:hover,
                &:active {
                  opacity: 1;
                  transition: all 0.5s;
                }
              }
            }

            .denoise {
              font-size: 25px;
            }

            .denoise_value {
              height: 50px;
              width: 100%;
              border: 2px solid @basicselect;
              border-radius: 10px;
              text-align: left;
              padding: 0 10px;
              color: @font_black;
              font-size: 22px;
              opacity: 0.6;

              &:hover,
              &:active {
                opacity: 1;
                transition: all 0.5s;
              }
            }
          }
        }

        .gap {
          width: 15px;
        }

        .button {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 335px;
          color: @font_black;

          button {
            height: 105px;
            border: none;
            border-radius: 25px;
            background-color: @morejoy;
            color: @font_white;
            cursor: pointer;
            font-size: 25px;
            font-family: "icomoon";
            transition: all 0.5s;

            &:hover {
              transition: all 0.5s;
              font-size: 27px;
              color: @font_white;
            }

            &:active {
              transition: all 0.5s;
              font-size: 29px;
            }
          }
        }
      }

      .sdpara {
        display: flex;
        width: 100%;
        height: 70px;
        justify-content: space-between;
        align-items: center;
        font-size: 25px;
        padding: 0 15px;
        border-radius: 15px;
        color: @font_gray;
        border: 2px solid @basicselect;

        .switch {
          display: flex;
          align-items: center;
          gap: 0 15px;
        }
      }

      .ctrl {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 15px;
        gap: 15px 0;
        border: 2px solid @basicselect;
        border-radius: 20px;

        .ctrl_1,
        .ctrl_2,
        .ctrl_3 {
          display: flex;
          flex-direction: column;
          width: 100%;
          height: auto;
          font-size: 25px;
          gap: 10px 0;

          .one {
            display: flex;
            font-size: 25px;
            color: @font_gray;
            justify-content: space-between;
            align-items: center;
            gap: 0 5px;

            .gap {
              width: 180px;
            }

            select {
              width: 350px;
              height: 50px;
              font-size: 22px;
              color: @font_gray;
              padding: 5px 10px;
              border-radius: 12px;
              border: 2px solid @basicselect;
              background: none;
            }
          }

          .two {
            display: flex;
            font-size: 25px;
            color: @font_gray;
            justify-content: space-between;
            align-items: center;
            gap: 0 5px;

            .gap {
              width: 300px;
            }

            input {
              width: 150px;
              height: 50px;
              border: 2px solid @basicselect;
              border-radius: 13px;
              padding: 3px;
              font-size: 21px;
              text-align: center;
              color: @font_gray;
              opacity: 0.6;

              &:hover,
              &:active {
                opacity: 1;
                transition: all 0.5s;
              }
            }
          }

          .three {
            position: relative;
            width: 100%;
            height: 500px;
            border-radius: 20px;
            border: 2px solid @basicselect;
            font-size: 25px;
            color: @font_gray;

            span {
              cursor: pointer;
              transition: all 0.5s;
            }

            span:nth-child(1) {
              position: absolute;
              display: inline-block;
              left: 5%;
              top: 3%;
            }

            span:nth-child(2) {
              position: absolute;
              display: inline-block;
              right: 5%;
              top: 3%;
              padding: 0px 0px;
              z-index: 5;

              &:hover {
                transition: all 0.5s;
                font-size: 27px;
              }
            }

            div {
              position: absolute;
              width: 95%;
              height: 85%;
              background: @basicselect;
              border-radius: 15px;
              top: 55%;
              left: 50%;
              transform: translate(-50%, -50%);
              z-index: 0;
              cursor: pointer;
              overflow: hidden;
              transition: all 0.5s;

              &:hover {
                transition: all 0.5s;
                box-shadow: 0 0 8px 3px @basicselect;
              }

              .upload {
                position: absolute;
                display: inline-block;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                z-index: 1;
                transition: all 0.5s;

                &:hover {
                  transition: all 0.5s;
                  font-size: 27px;
                }
              }

              .ctrl_image {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                height: 100%;
                z-index: 2;
              }
            }
          }
        }
      }
    }

    .middle {
      width: 15px;
    }

    .right {
      width: 805px;
      display: flex;
      position: relative;
      color: @font_white;

      .show_image {
        position: absolute;
        top: 20px;
        left: 20px;
        width: 180px;
        height: 50px;
        background-color: rgba(75, 75, 75, 0.436);
        border-radius: 15px;
        font-size: 25px;
        text-align: center;
        line-height: 50px;
        cursor: pointer;
        transition: all 0.5s;

        &:hover {
          background-color: rgba(75, 75, 75, 1);
        }
      }

      .panel {
        position: relative;
        width: 100%;
        height: 1350px;
        background-color: @basicselect;
        border-radius: 25px;
        cursor: pointer;
        transition: all 0.5s;
        border: 2px solid transparent;
        overflow: hidden;

        .tips {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 30px;
          color: @font_black;
          z-index: 4;
        }

        img {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 100%;
          outline: none;
          z-index: 2;
        }

        &:hover {
          transition: all 0.5s;
          box-shadow: 0 0 8px 3px @basicselect;
        }

        .copy_path {
          position: absolute;
          text-align: center;
          right: 10px;
          bottom: 10px;
          width: 120px;
          height: 50px;
          font-size: 25px;
          color: @font_gray;
          z-index: 4;
          transition: all 0.5s;

          &:hover {
            font-size: 27px;
          }
        }
      }
    }
  }
}
</style>
